
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import UploadAdapter from "../../components/UI/form/UploadAdapter";

const CheckTextEditor = () => {

    const changeDataHandler = (value) => {

    }

    const config = {
        language: "en",
        height: 300,
        extraPlugins: [uploadPlugin],
        ui: {
            viewportTopOffset: 60,
        }
    };

    function uploadPlugin(editor) {
        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
            return UploadAdapter(loader, true);
        };
    }

    return <div>
        <CKEditor
            editor={ClassicEditor}
            config={config}
            data={'test'}
            onChange={( event, editor ) => {
                changeDataHandler( editor.getData())
            }}
        />
    </div>
}

export default CheckTextEditor;